
document.addEventListener('DOMContentLoaded', function() {
  // Handle scroll-to-top functionality for image banner buttons in this section
  const scrollButtons = document.querySelectorAll('.image-banner-button-template--30445709951324__image_banner_YMbDGW[data-scroll-to-top]');
  
  scrollButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  });

  // Prevent default behavior for buttons with href="#" that don't have scroll functionality
  const allBannerButtons = document.querySelectorAll('.image-banner-button-template--30445709951324__image_banner_YMbDGW');
  allBannerButtons.forEach(button => {
    if (button.getAttribute('href') === '#' && !button.hasAttribute('data-scroll-to-top')) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        console.warn('⚠️ Image banner button clicked but no valid redirect URL is set. Please configure the product or URL in the section settings.');
      });
    }
  });
});
